/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoicePaymentControllerImportCsv200Response
 */
export interface InvoicePaymentControllerImportCsv200Response {
    /**
     * 
     * @type {number}
     * @memberof InvoicePaymentControllerImportCsv200Response
     */
    imported?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePaymentControllerImportCsv200Response
     */
    skipped?: number;
}

/**
 * Check if a given object implements the InvoicePaymentControllerImportCsv200Response interface.
 */
export function instanceOfInvoicePaymentControllerImportCsv200Response(value: object): value is InvoicePaymentControllerImportCsv200Response {
    return true;
}

export function InvoicePaymentControllerImportCsv200ResponseFromJSON(json: any): InvoicePaymentControllerImportCsv200Response {
    return InvoicePaymentControllerImportCsv200ResponseFromJSONTyped(json, false);
}

export function InvoicePaymentControllerImportCsv200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicePaymentControllerImportCsv200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'imported': json['imported'] == null ? undefined : json['imported'],
        'skipped': json['skipped'] == null ? undefined : json['skipped'],
    };
}

export function InvoicePaymentControllerImportCsv200ResponseToJSON(value?: InvoicePaymentControllerImportCsv200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'imported': value['imported'],
        'skipped': value['skipped'],
    };
}

